import { createSelector } from 'reselect'

const list = (list) => ({ list })
const mapForDropdown = ({ list }) => {
  let entryList = list

  return list && Array.isArray(list)
    ? entryList.map(item => ({
        id: item.id,
        label: item.modeOfTransportType.translationText,
        value: item.modeOfTransportType.value,
      }))
    : []
}

export default createSelector(list, mapForDropdown)
